import React, { useState, useEffect } from 'react'
import { getUserProfile } from '../../../lib/project'
import { getBuilderTypePage } from '../../../store/project/builderTypePage'

export const ProfileContext = React.createContext()
export const ProfileRefreshContext = React.createContext()

export const useProfile = () => React.useContext(ProfileContext)

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState({})

  useEffect(() => {
    try {
      let builderType = getBuilderTypePage()
      if (['titanfiles'].includes(builderType)) {
        return () => {}
      }
    } catch (err) {
      console.error(err)
    }
    getUserProfile().then((data) => {
      if (data.userID === 237093) {
        data.isAdmin = true
      }
      setProfile(data)
    }, console.error)
  }, [])

  return <ProfileContext.Provider value={profile}>{children}</ProfileContext.Provider>
}
